module.exports = __webpack_public_path__ + "img/speed.34464d17.svg";